module.exports = __webpack_public_path__ + "img/google15.83d507e3.jpg";